<template>
  <div>
    <ol class="am-breadcrumb" v-if="id">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li>
        <router-link :to="{path:'/edit/posts'}">文章</router-link>
      </li>
      <li class="am-active" v-if="id">{{title}}</li>
    </ol>
    <ol class="am-breadcrumb" v-else>
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">撰写</li>
      <li class="am-active">撰写文章</li>
    </ol>
    <div class="am-form" v-show="editor">
      <div class="am-form-group">
        <label for="title">文章标题</label>
        <input id="title" type="text" class="am-form-field am-radius" placeholder="请输入文章标题..." v-model="title"/>
      </div>
      <div class="am-form-group">
        <label for="content">文章内容</label>
        <textarea id="content" class="am-form-field am-radius" placeholder="请输入文章内容..." rows="20" v-model="content"></textarea>
      </div>
      <div class="am-form-group">
        <label for="banner">文章头图url</label>
        <input id="banner" type="text" class="am-form-field am-radius" placeholder="请输入文章头图url..." v-model="banner"/>
      </div>
      <div class="am-form-group">
        <label for="admiration">赞赏图片url</label>
        <input id="admiration" type="text" class="am-form-field am-radius" placeholder="请输入赞赏图片url..." v-model="admiration"/>
      </div>
      <div class="am-form-group">
        <label for="status">文章公开度</label>
        <select id="status" v-model="status">
          <option value="1">公开</option>
          <option value="2">隐藏</option>
          <option value="3">密码保护</option>
          <option value="4">私密</option>
        </select>
        <span class="am-form-caret"></span>
      </div>
      <div class="am-form-group" v-show="status==3">
        <label for="password">文章密码</label>
        <input id="password" type="text" class="am-form-field am-radius" placeholder="请输入文章密码..." v-model="password"/>
      </div>
      <div class="am-form-group">
        <label class="am-radio-inline">
          <input type="radio" name="type" value="1" v-model="type"> 原创
        </label>
        <label class="am-radio-inline">
          <input type="radio" name="type" value="2" v-model="type"> 转载
        </label>
      </div>
      <div class="am-form-group" v-show="type==2">
        <label for="source">转载来源</label>
        <input id="source" type="text" class="am-form-field am-radius" placeholder="例：转自http://www.xxxx.com/yyyy" v-model="source"/>
      </div>
      <div class="am-form-group">
        <label class="am-radio-inline">
          <input type="radio" name="allowComment" value="true" v-model="allowComment"> 允许评论
        </label>
        <label class="am-radio-inline">
          <input type="radio" name="allowComment" value="false" v-model="allowComment"> 不允许评论
        </label>
      </div>
      <div class="am-form-group am-margin-bottom-xs" v-if="typeList && typeList.length > 0">
        文章分类：
        <label class="am-checkbox-inline" v-for="type in typeList" :key="type.id" :for="`type_${type.id}`">
          <input type="checkbox" :id="`type_${type.id}`" :value="type.id" v-model="typeIdList"/> {{type.title}}
        </label>
      </div>
      <div class="am-form-group am-margin-bottom-xs" v-if="tagList && tagList.length > 0">
        文章标签：
        <label class="am-checkbox-inline" v-for="tag in tagList" :key="tag.id" :for="`tag_${tag.id}`">
          <input type="checkbox" :id="`tag_${tag.id}`" :value="tag.id" v-model="tagIdList"/> {{tag.title}}
        </label>
      </div>
      <div class="am-form-group am-margin-top">
        <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
        <button class="am-btn am-btn-secondary am-btn-xs" @click="preview">预览</button>
      </div>
    </div>
    <div v-show="!editor">
      <article class="am-article">
        <div class="am-article-hd">
          <h1 class="am-article-title">
            {{title}}
            <button class="am-btn am-btn-secondary am-btn-xs" @click="edit">返回编辑</button>
            <button class="am-btn am-btn-primary am-btn-xs" @click="save">保存</button>
          </h1>
        </div>
        <div v-highlight class="am-article-bd" v-html="html"></div>
      </article>
    </div>
    <ol class="am-breadcrumb" v-if="id">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li>
        <router-link :to="{path:'/edit/posts'}">文章</router-link>
      </li>
      <li class="am-active" v-if="id">{{title}}</li>
    </ol>
    <ol class="am-breadcrumb" v-else>
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">撰写</li>
      <li class="am-active">撰写文章</li>
    </ol>
  </div>
</template>

<script>
import marked from 'marked'
import hljs from "highlight.js"
import 'highlight.js/styles/vs2015.css'
import { adminTypeGetList, adminTagGetList, adminPostGet, adminPostSave } from '@/request'
import {Toast} from "mint-ui"
export default {
  name: 'EditPost',
  data () {
    return {
      editor: true,
      id: null,
      title: '',
      content: '',
      allowComment: false,
      banner: '',
      admiration: '',
      status: 4,
      password: '',
      type: 1,
      source: '',
      typeIdList: [],
      tagIdList: [],
      typeList: [],
      tagList: []
    }
  },
  mounted () {
    this.resetData()
  },
  computed: {
    html () {
      return marked.parse(this.content)
    }
  },
  watch: {
    $route: {
      handler: 'resetData'
    },
    title (val) {
      document.title = `${val}｜编辑`
    }
  },
  methods: {
    resetData () {
      const id = this.$route.params.id
      if(id) {
        adminPostGet({ id, typeData: true, tagData: true }).then(res => {
          this.id = res.id
          this.title = res.title
          this.content = res.content
          this.allowComment = res.allowComment
          this.banner = res.banner
          this.admiration = res.admiration
          this.status = res.status
          this.password = res.password
          this.type = res.type
          this.source = res.source
          this.typeIdList = res.typeList.map(e => e.id)
          this.tagIdList = res.tagList.map(e => e.id)
        })
      }
      adminTypeGetList().then(res => {
        this.typeList = res
      })
      adminTagGetList().then(res => {
        this.tagList = res
      })
      const renderer = new marked.Renderer()
      const linkRenderer = renderer.link
      renderer.link = (href, title, text) => {
        const html = linkRenderer.call(renderer, href, title, text)
        return html.replace(/^<a /, '<a target="_blank" ')
      }
      marked.setOptions({
        renderer: renderer,
        pedantic: false,
        gfm: true,
        tables: true,
        breaks: true,
        sanitize: false,
        smartLists: true,
        smartypants: false,
        xhtml: false
      })
    },
    preview () {
      this.editor = false
    },
    edit () {
      this.editor = true
    },
    save () {
      adminPostSave({
        id: this.id,
        title: this.title,
        content: this.content,
        allowComment: this.allowComment,
        banner: this.banner,
        admiration: this.admiration,
        status: this.status,
        password: this.password,
        type: this.type,
        source: this.source,
        typeIdList: this.typeIdList,
        tagIdList: this.tagIdList
      }).then(res => {
        this.id = res
        Toast("保存成功")
        this.$router.push({path:`/edit/post/${this.id}`})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditPost.vue